import { render, staticRenderFns } from "./vehicles.vue?vue&type=template&id=63f46d7b&"
import script from "./vehicles.vue?vue&type=script&lang=js&"
export * from "./vehicles.vue?vue&type=script&lang=js&"
import style0 from "./vehicles.vue?vue&type=style&index=0&id=63f46d7b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports